import dayjs from "dayjs";
import { upperCase } from "lodash-es";
import * as xlsx from "xlsx";
//#region src/modules/Locations/shared/location-checkpoint-scans-summary-download.ts
function locationCheckpointScansSummaryDownload(scans, deps, config) {
	const arrayOfArrays = [[
		"Type",
		"Date",
		"Time",
		"Checkpoint Name",
		"User",
		"Device"
	]];
	scans.forEach((scan) => {
		let userString = "";
		if (scan.scan.user?.displayName) userString += scan.scan.user?.displayName;
		if (scan.scan.user?.idNumber) userString += ` (${scan.scan.user?.idNumber})`;
		arrayOfArrays.push([
			upperCase(scan.scan.checkpointType),
			dayjs(scan.scan.timestamp).format("YYYY/MM/DD"),
			dayjs(scan.scan.timestamp).format("hh:mm A"),
			scan.scan.checkpointName,
			userString,
			scan.scan.geo?.device.name || ""
		]);
	});
	const ws = xlsx.utils.aoa_to_sheet(arrayOfArrays);
	const wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, "Summary");
	if (config.format === "csv") xlsx.writeFile(wb, `${config.fileName}.csv`, { bookType: "csv" });
	else xlsx.writeFile(wb, `${config.fileName}.xlsx`, { bookType: "xlsx" });
}
//#endregion
export { locationCheckpointScansSummaryDownload };

//# sourceMappingURL=location-checkpoint-scans-summary-download.js.map